import PropTypes from "prop-types";
import { PaymentMethodSelector } from "../../../lib/reservationPayment";

const formatMoney = (value) =>
    Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const CarSwapPaymentStep = ({ dueAmount, paymentOptions, paymentSystem, onPaymentChange, t }) => (
    <div className="space-y-4">
        <div className="rounded-lg border border-[#EEF0F6] bg-[#F0F7FF] px-4 py-3">
            <p className="fontRegular text-sm text-[#667085]">{t("carSwapModal.paymentStepDueLabel")}</p>
            <p className="fontSemi mt-1 text-2xl text-[#5D5DF6]">${formatMoney(dueAmount)}</p>
        </div>

        <PaymentMethodSelector
            compact
            title={t("carSwapModal.paymentMethodTitle")}
            subtitle={t("carSwapModal.paymentMethodSubtitle")}
            options={paymentOptions}
            value={paymentSystem}
            onChange={onPaymentChange}
        />
    </div>
);

CarSwapPaymentStep.propTypes = {
    dueAmount: PropTypes.number.isRequired,
    paymentOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
    paymentSystem: PropTypes.string,
    onPaymentChange: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default CarSwapPaymentStep;
